export interface TabsItemProps
  extends React.DetailedHTMLProps<
    React.LiHTMLAttributes<HTMLLIElement>,
    HTMLLIElement
  > {
  isActive?: boolean
  isActiveTailwind?: string
  defaultTailwind?: string
  onClickAction?: () => void
}
export const TabsItem = ({
  isActive = false,
  isActiveTailwind = "tw-bg-white tw-text-primary tw-font-medium tw-shadow",
  defaultTailwind = "tw-select-none tw-flex tw-justify-center tw-items-center tw-text-sm tw-text-neutral-75 tw-rounded tw-py-3 tw-px-10 tw-cursor-pointer hover:tw-text-black hover:tw-shadow tw-transition-shadow tw-duration-150 tw-ease-in-out",
  ...liProps
}: TabsItemProps) => {
  const tailwindStyle = [
    defaultTailwind,
    isActive ? isActiveTailwind : "",
  ].join(" ")
  const restLiProps = Object.fromEntries(
    Object.entries(liProps).filter(([key]) => key !== "onClickAction")
  )

  return (
    <li
      className={tailwindStyle}
      {...restLiProps}
    />
  )
}
